exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nbutton[data-v-0d3bbca8] {\n  border: none;\n}\n.question[data-v-0d3bbca8] {\n  margin: 10px;\n}\n\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/GrammarGame/game-page.vue"],"names":[],"mappings":";AACA;EACE,aAAa;CACd;AACD;EACE,aAAa;CACd","file":"game-page.vue","sourcesContent":["\nbutton[data-v-0d3bbca8] {\n  border: none;\n}\n.question[data-v-0d3bbca8] {\n  margin: 10px;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0d3bbca8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/GrammarGame/game-page.vue
// module id = 408
// module chunks = 1 3